import React, { useState, useContext } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import _ from "lodash";
import {
  DropdownInput,
  TextAreaInputField,
  Snackbar,
  Button,
  Loading,
} from "components";
import { modifyList, generateDropdownOptions } from "utils";
import { TICKET_CATEGORY_OPTIONS } from "constants";
import { TicketServices } from "services";
import { UserContext } from "contexts";
import { useSnackbar } from "hooks";
import OrderItems from "pages/Orders/MyOrders/MyOrdersList/OrderDetail/OrderItems";
import "./index.css";

const AddTicketForm = ({
  ticketDetail,
  ticketCategory,
  orderDetail,
  onCloseDrawer,
}) => {
  const { currentUser } = useContext(UserContext);
  const snackbar = useSnackbar();
  // const [attachments, setAttachments] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);

  const { _id, category, description, statusIndex } = ticketDetail || {};
  const { _id: orderId, products } = orderDetail || {};

  return (
    <Formik
      initialValues={{
        category: ticketCategory || category || "Select Category",
        description: description || "",
      }}
      validationSchema={Yup.object().shape({
        category: Yup.string()
          .required("Ticket Category is mandatory")
          .test(
            "description",
            "Ticket Description is Mandatory",
            (value) => !_.isEmpty(value) && value !== "Select Category"
          ),
        description: Yup.string()
          .required("Ticket description is mandatory")
          .max(1000, "Ticket Description should not exceed 250 characters"),
      })}
      validateOnBlur
      validateOnChange
      onSubmit={async (values, { setSubmitting }) => {
        let payload = {
          ...values,
          // attachments,
          customerId: currentUser?._id,
        };
        if (!_.isEmpty(orderId)) {
          payload = {
            ...payload,
            orderId,
            orderItems: selectedItems,
          };
        }
        if (_id) {
          payload = {
            ...payload,
            statusIndex: statusIndex + 1,
          };
        } else {
          payload = {
            ...payload,
            statusList: [
              {
                description: "Created",
                timestamp: new Date(),
              },
            ],
          };
        }
        setSubmitting(true);
        const { msg, ticketData } = await TicketServices.createUpdateTicket(
          payload
        );
        setSubmitting(false);
        snackbar.showMessage({
          content: msg,
          timeout: 5000,
          handleClose: onCloseDrawer && onCloseDrawer(ticketData),
        });
      }}
    >
      {({
        values,
        handleChange,
        handleBlur,
        touched,
        errors,
        isSubmitting,
        handleSubmit,
      }) => (
        <>
          <Snackbar {...snackbar} />
          {isSubmitting && <Loading />}
          <div className="addTicket__form">
            <p className="addTicket__form-header">RAISE TICKET</p>
            <div className="addTicket__form-container">
              <div className="addTicket__form--left">
                <OrderItems
                  products={products}
                  isSelectMode
                  selectedItems={selectedItems}
                  onSelectItem={(itemId) =>
                    setSelectedItems((prevList) => modifyList(prevList, itemId))
                  }
                />
              </div>
              <div className="addTicket__form--right">
                <div className="addTicket__form-selectCategory">
                  <span>Select Category</span>
                  <DropdownInput
                    name="category"
                    className="addTicket__form-selectCategory-dropdown"
                    optionsList={generateDropdownOptions(TICKET_CATEGORY_OPTIONS)}
                    selectedOption={values.category}
                    onSelect={handleChange}
                    onBlur={handleBlur}
                    errorText={touched.category && errors.category}
                  />
                </div>
                <div className="addTicket__form-attachImages">
                  <p className="addTicket__form-attachImages-label">
                    Add Images for Reference
                  </p>
                  {/* Drag and Drop Component */}
                </div>
                <TextAreaInputField
                  name="description"
                  className="addTicket__form-description"
                  minRows={7}
                  labelText="Describe the issue*"
                  inputValue={values.description}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  errorText={touched.description && errors.description}
                />
                <div className="addTicket__form-buttons">
                  <Button
                    id="btnInput"
                    className="addTicket__form-cancel"
                    onClick={() => onCloseDrawer()}
                  >
                    Cancel Ticket
                  </Button>
                  <Button
                    id="btnInput"
                    className="addTicket__form-submit"
                    onClick={() => handleSubmit()}
                  >
                    Raise Ticket
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </Formik>
  );
};

export default AddTicketForm;
